import { apiClient } from './api';

export type TrailerQrPayload = {
    id?: string;
    trailer_no?: string;
};


/**
 * Fetch scanned trailer details using QR payload
 */
export const getScannedTrailer = async (payload: TrailerQrPayload) => {
    const result = await apiClient.post<{
        message: string;
        data: any;
    }>('/trailer/getScannedTrailer', {
        id: payload.id,
        trailer_no: payload.trailer_no,
    });

    return result.data;
};


/**
 * Fetch trailer list with pagination + filters
 */
export const getTrailerList = async (payload: {
    page: number;
    limit: number;
    filters?: any;
    dates?: any;
}) => {
    const result = await apiClient.post<{
        data: any[];
        totalRows: number;
    }>('/trailer/getTrailerList', {
        page: payload.page,
        limit: payload.limit,
        ...(payload.filters || {}),
        ...(payload.dates || {}),
    });

    return result;
};


/**
 * Delete trailer by trailer number.
 */
export const deleteTrailer = async (trailer_no: string) => {
    const result = await apiClient.post<{
        message: string;
    }>('/trailer/deleteTrailer', { trailer_no });

    return result;
};


/**
 * Update multiple trailers at once.
 */
export const updateMultipleTrailers = async (trailers: any[]) => {
    const result = await apiClient.post<{
        message: string;
    }>('/trailer/multipleUpdate', { trailers });

    return result;
};


/**
 * Update trailer location (map coordinates)
 */
export const updateTrailerLocation = async (trailer: any) => {
    const result = await apiClient.post<{
        message: string;
    }>('/trailer/updateTrailerLocation', { trailer });

    return result;
};


/**
 * Update all trailer info (bulk save)
 */
export const updateAllTrailersInfo = async (trailers: any[]) => {
    const result = await apiClient.post<{
        message: string;
    }>('/trailer/updateAllTrailersInfo', { trailers });

    return result;
};